import ResponsivePagination, { type ResponsivePaginationProps } from "react-responsive-pagination";
import "./index.scss";

interface ExtendedPaginationProps extends ResponsivePaginationProps {
  customClass?: string;
}

export function Pagination({
  current,
  total,
  onPageChange,
  customClass,
  ...rest
}: ExtendedPaginationProps) {
  return (
    <div className="pagination-wrapper">
      <ResponsivePagination
        current={current}
        total={total}
        onPageChange={onPageChange}
        className={`pagination ${customClass ?? ""}`}
        {...rest}
      />
    </div>
  );
}
